import { Outlet } from 'react-router';
import { UserContextV2 } from '~/app';
import { Layout } from '~/components/Layout';
import { HlxSideMenu } from '~/components/Layout/SideNav/HlxSideMenu';
import { ServiceWorkspaceBoundary } from '~/features/market/service-opportunities/ServiceResponseBoundary';
import { ResponseUnmaskWorkspaceBoundary } from '~/features/shared/market-content/ResponseUnmaskBoundary';
import { ReceivedResponseActionsBoundary } from '~/features/shared/useReceivedResponseActions';
import { paths } from './routes';
import { useMarketPageSync } from './useMarketPageSync';

export const HlxLayout = () => {
  // [MCV-1537] Mounted once here because this layout wraps every authenticated
  // /hlx/* route, so one hook covers navigation from cards, the sidebar, browser
  // back/forward and redirects alike.
  useMarketPageSync();
  const isProvider = UserContextV2.useSelector((state) =>
    state.matches({ $_AUTHENTICATED: '$_AUTHENTICATED_PROVIDER' })
  );

  return (
    <Layout
      mobileLogo="hlx"
      switchTargetPath={isProvider ? paths.vault.dashboard : undefined}
      renderSideMenu={({ keyPrefix, onCollapse }) => (
        <HlxSideMenu keyPrefix={keyPrefix} onCollapse={onCollapse} />
      )}
    >
      <ReceivedResponseActionsBoundary recoveryLinks>
        <ServiceWorkspaceBoundary>
          <ResponseUnmaskWorkspaceBoundary>
            <Outlet />
          </ResponseUnmaskWorkspaceBoundary>
        </ServiceWorkspaceBoundary>
      </ReceivedResponseActionsBoundary>
    </Layout>
  );
};
